// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.feedback,
.user-guide,
.rating {
  text-align: center;
  margin-top: 15px;
}
.feedback a,
.user-guide a,
.rating a {
  margin-left: 0;
  margin-right: 0;
}
.feedback img,
.user-guide img,
.rating img {
  width: 30px;
}
.feedback span,
.user-guide span,
.rating span {
  display: block;
  color: #000;
  font-size: 12px;
}

.rating {
  margin-top: 10px;
}
.rating a:hover {
  cursor: pointer;
}
.rating a > i {
  color: #0B2D71 !important;
  font-size: 35px;
}

.flagBox {
  float: right;
  width: 100px;
  height: 75px;
}

.flag {
  max-width: 50%;
  max-height: 50%;
}

:host .user {
  display: flex;
  padding: 20px;
  color: #0b2d71;
  font-family: "GothamBook";
}
:host .user img {
  border-radius: 50%;
  height: 35px;
  width: 35px;
  margin-left: 15px;
}
:host .user span {
  display: grid;
  font-size: 16px;
  font-weight: bolder;
}
:host .user span span {
  font-size: 12px;
  font-weight: 300;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
